import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Share, X } from "lucide-react";
import icon from "@/assets/bb-icon-tile.webp";

const KEY = "bb-a2hs-hint-done";
const standalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone;

// One-time "Add to Home Screen" hint on phones (login page and after first login). No service worker, no data caching.
export function InstallHint() {
  const { pathname } = useLocation();
  const [evt, setEvt] = useState(null);
  const [show, setShow] = useState(false);
  useEffect(() => {
    const h = (e) => { e.preventDefault(); setEvt(e); };
    window.addEventListener("beforeinstallprompt", h);
    return () => window.removeEventListener("beforeinstallprompt", h);
  }, []);
  useEffect(() => {
    const phone = window.matchMedia?.("(max-width: 767px)").matches;
    const where = pathname === "/login" || pathname === "/" || pathname.startsWith("/portal");
    if (!(phone && where && !standalone() && !localStorage.getItem(KEY))) return setShow(false);
    const t = setTimeout(() => setShow(true), 4000);
    return () => clearTimeout(t);
  }, [pathname]);
  if (!show) return null;
  const done = () => { localStorage.setItem(KEY, "1"); setShow(false); };
  const ios = /iphone|ipad|ipod/i.test(navigator.userAgent);
  const install = async () => { if (evt) { evt.prompt(); await evt.userChoice.catch(() => {}); } done(); };
  return (
    <div data-testid="a2hs-hint" className="fixed inset-x-3 bottom-20 md:hidden z-[60] rounded-2xl bg-[#262357] text-white shadow-2xl p-4 flex items-start gap-3">
      <img src={icon} alt="" width={40} height={40} loading="lazy" className="rounded-lg bg-white" />
      <div className="flex-1 text-sm">
        <p className="font-semibold">Add BusinessBook to your home screen</p>
        <p className="text-white/80 mt-0.5">{ios ? <>Tap <Share className="inline w-4 h-4" /> Share, then “Add to Home Screen”.</> : "Open it like an app, in one tap."}</p>
        {!ios && evt && <button data-testid="a2hs-install" onClick={install} className="mt-2 h-11 px-4 rounded-full bg-white text-[#262357] font-semibold">Install</button>}
      </div>
      <button data-testid="a2hs-dismiss" aria-label="Dismiss" onClick={done} className="h-11 w-11 -m-2 grid place-items-center text-white/80"><X className="w-5 h-5" /></button>
    </div>
  );
}
